import { createContext, useContext } from 'react';
/**
 * Whole section context
 *
 * @documented
 * @category Context
 * @import import SectionContext from '@gef-ui/form-core/context/section'
 *
 */ const SectionContext = /*#__PURE__*/ createContext();
/**
 * SectionContext provider
 *
 * @documented
 * @category Context
 * @import import { Provider as SectionProvider } from '@gef-ui/form-core/context/section';
 * @example
 *
 * 	<SectionProvider value="Overlord">
 * 		xxx
 * 	</SectionProvider>
 *
 */ export const Provider = SectionContext.Provider;
/**
 * Hook which will give you value from section context
 *
 * @documented
 * @category Context
 * @import import { useSectionContext } from '@gef-ui/form-core/context/section'
 * @returns {String} sectionName
 * @example
 *
 * 	const section = useSectionContext();
 *
 */ export const useSectionContext = ()=>useContext(SectionContext);
export default SectionContext;
